import { createContext, useContext, useState } from "react";
import { api } from "../api/api"; // Added API import for backend logout

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [vendor, setVendor] = useState(() => {
    try {
      const stored = localStorage.getItem("vendor");
      if (!stored || stored === "undefined") {
        return null;
      }
      return JSON.parse(stored);
    } catch (error) {
      console.log("JSON parse error:", error);
      return null;
    }
  });

  // Track the access token specifically
  const [token, setToken] = useState(
    localStorage.getItem("vendor_access_token")
  );

  const login = (data) => {
    // Save both tokens returned from the new backend
    localStorage.setItem("vendor_access_token", data.access_token);
    localStorage.setItem("vendor_refresh_token", data.refresh_token);
    
    localStorage.setItem("vendor", JSON.stringify(data.vendor));
    localStorage.setItem("vendor_id", data.vendor.id);

    setToken(data.access_token);
    setVendor(data.vendor);
  };

  const logout = async () => {
    // Attempt to notify backend to blocklist tokens (graceful fail if network error)
    try {
      const currentToken = localStorage.getItem("vendor_access_token");
      if (currentToken) {
        await api.post("/auth/logout");
      }
    } catch (error) {
      console.log("Backend logout failed or token already expired.");
    }

    // Clear everything from local storage
    localStorage.removeItem("vendor_access_token");
    localStorage.removeItem("vendor_refresh_token");
    localStorage.removeItem("vendor");
    localStorage.removeItem("vendor_id");
    
    setVendor(null);
    setToken(null);
    
    // REDIRECT TO LOGIN
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{
        vendor,
        token, // Exposing the access token
        login,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);